import { render } from "./MFITTResevationCard.vue?vue&type=template&id=22d2277c"
import script from "./MFITTResevationCard.vue?vue&type=script&lang=js"
export * from "./MFITTResevationCard.vue?vue&type=script&lang=js"

import "./MFITTResevationCard.vue?vue&type=style&index=0&id=22d2277c&lang=scss"
script.render = render

export default script